import ShowroomHeaderImage from "./showroom-header-image";

export default ShowroomHeaderImage;